angular.module('unica_media_directory.archive_media_directory_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// media_directory
		.state('app.archive_media_directory', {
			url: '/archive-media-directory',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/media-directory/templates/media-directory.html',
					controller: 'ArchiveMediaDirectoryBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

		// media_directory LIST AND DELETE
		.state('app.archive_media_directory.list', {
			url: '/list/:event_id',
			views: {
				'mediaDirectoryContent': {
					templateUrl: './modules/media-directory/templates/list.html',
					controller: 'ArchiveMediaDirectoryListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Lista Archivio Directory',
				parent: function($scope) {
					return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + ' })';
				}
			}
		})

		// media_directory CREATE
		.state('app.archive_media_directory.create', {
			url: '/create/:event_id',
			views: {
				'mediaDirectoryContent': {
					templateUrl: './modules/media-directory/templates/create.html',
					controller: 'ArchiveMediaDirectoryCreateController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Aggiungi Archivio Directory',
				parent: 'app.archive_media_directory.list'
			}
		})

		// media_directory EDIT
		.state('app.archive_media_directory.edit', {
			url: '/edit/:event_id/:id',
			views: {
				'mediaDirectoryContent': {
					templateUrl: './modules/media-directory/templates/edit.html',
					controller: 'ArchiveMediaDirectoryEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Archivio Directory',
				parent: 'app.archive_media_directory.list'
			}
		});

});

